import { Icon } from '@chakra-ui/react'

export const DiagrammIcon = props => (
  <Icon viewBox='0 0 13 12' {...props}>
    <svg width='13' height='12' viewBox='0 0 13 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M12.4955 0H8.498C8.21978 0 7.99346 0.240859 7.99346 0.536947V3.3168H4.50056C4.22233 3.3168 3.99601 3.55766 3.99601 3.85375V6.67195H0.504547C0.226325 6.67195 0 6.91281 0 7.2089V11.4631C0 11.7591 0.226325 12 0.504547 12H12.4955C12.7737 12 13 11.7591 13 11.4631V0.536947C13 0.240859 12.7737 0 12.4955 0ZM3.99745 10.9246H1.00909V7.74431H3.99745V10.9246ZM7.9949 10.9246H5.00654V4.38916H7.9949V10.9246ZM11.9923 10.9246H9.00399V1.07389H11.9923V10.9246Z'
        fill='currentColor'
      />
    </svg>
  </Icon>
)
